import { useQuery } from '../../_commons/query';

export default function useRatesTags({
  dispatch,
  getRatesTags,
  integrationSettings,
  prePopulation,
  meta,
  pageContext,
  selectedItems,
  rateTagsData
}) {
  let ratesTags = [];

  if (rateTagsData && rateTagsData.length > 0) {
    ratesTags = rateTagsData;
  } else {
    const getData = () => {
      return getRatesTags(prePopulation, integrationSettings, meta, pageContext)
        .then((data) => {
          return data;
        })
        .catch((err) => {
          throw err;
        });
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    ratesTags = useQuery({ getData }, [
      integrationSettings,
      prePopulation.travelerInterest,
      meta,
      pageContext,
      getRatesTags
    ]);
  }

  const onChange = (payload) => {
    dispatch({
      type: 'RATES_TAGS_CHANGE',
      payload
    });
  };

  const onClear = (payload) => {
    dispatch({
      type: 'RATES_TAGS_CLEAR',
      payload
    });
  };

  return {
    values: ratesTags,
    selectedItems,
    onChange,
    onClear
  };
}
